<button
    [ngClass]="combinedClass"
    [disabled]="disabled"
    [class.active]="active"
    [type]="type"
    [attr.aria-label]="aria"
    (click)="onClick($event)"
>
    @if (label.length > 0) {
        {{ label }}
    }
    <ng-content></ng-content>
</button>
